/**
 * WOMEN'S / MEN'S tabs for the size picker on unisex products.
 *
 * Each size input/label carries data-size-gender ("women" | "men" | "both" |
 * "kids"), assigned in variant-picker.liquid from the store's EU size chart.
 * Selecting a tab shows only that gender's sizes (shared sizes show in both).
 * If the currently selected size is hidden by a tab switch it is deselected,
 * which puts the buy button back into its "Select a Size" state via the
 * variant picker's own change handling.
 *
 * The same tabs drive which table is visible inside the #size-help modal.
 */
if (!customElements.get('size-gender-tabs')) {
  class SizeGenderTabs extends HTMLElement {
    connectedCallback() {
      this.fieldset = this.closest('fieldset');
      if (!this.fieldset) return;

      this.tabs = Array.from(this.querySelectorAll('.size-tabs__tab'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.gender));
      });

      // PDF default: women's sizes first.
      this.select('women', true);
    }

    select(gender, isInit = false) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.gender === gender;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.fieldset.querySelectorAll('[data-size-gender]').forEach((el) => {
        const group = el.dataset.sizeGender;
        const show = group === 'both' || group === 'kids' || group === gender;
        el.style.display = show ? '' : 'none';

        // Deselect a chosen size that the new tab hides.
        if (!isInit && !show && el.matches('input') && el.checked) {
          el.checked = false;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Keep the size-help modal on the matching gender table.
      document.querySelectorAll('#size-help [data-size-table]').forEach((table) => {
        table.hidden = table.dataset.sizeTable !== gender;
      });
    }
  }

  customElements.define('size-gender-tabs', SizeGenderTabs);
}
